import { injectable } from 'inversify';

import type { Config } from '../../../types/config';
import type { GetMediaParams } from '../../../types/media';
import type { GetTokenResponse } from '../../../types/entitlement';
import EntitlementService from '../EntitlementService';

@injectable()
export default class GenericEntitlementService extends EntitlementService {
  protected getToken = async <T>(url: string, body: unknown = {}): Promise<T> => {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    return (await response.json()) as T;
  };

  getMediaToken = async (config: Config, id: string, jwt?: string, params: GetMediaParams = {}, accessType?: string) => {
    const host = typeof config.custom?.entitlementHost === 'string' ? config.custom.entitlementHost : undefined;
    const provider = config.integrations.jwp?.clientId ? 'jwp' : config.integrations.cleeng?.id ? 'cleeng' : '';
    const drmPolicyId = (config.contentProtection?.drm?.defaultPolicyId || config.custom?.drmPolicyId) as string | undefined;

    if (!host) {
      throw new Error('GenericEntitlementService is missing the host in the config');
    }

    const data = await this.getToken<GetTokenResponse>(host, {
      provider,
      credentials: {
        token: jwt || '',
      },
      asset: {
        id,
        drmPolicyId,
        siteId: config.siteId,
        params,
        accessType,
      },
    });

    if (!data.entitled) throw new Error('Unauthorized');

    return data.token;
  };
}
